import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2079f3f8&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2079f3f8')) {
      api.createRecord('2079f3f8', component.options)
    } else {
      api.reload('2079f3f8', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=2079f3f8&", function () {
      api.rerender('2079f3f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/List.vue"
export default component.exports